import { INTERNAL_INFORMATION_DELIVERY_PAGE } from "@/data/marketing/capabilityPages";
import SegmentLandingPage from "@/pages/Segments/SegmentLandingPage";

const InternalInformationDeliveryPage = () => {
  return <SegmentLandingPage content={INTERNAL_INFORMATION_DELIVERY_PAGE} />;
};

export default InternalInformationDeliveryPage;
